var SCAAFFCustomerReferSetting = {
    "program": {
        "active": true,
        "shop": "unique-heat-next-generation.myshopify.com",
        "incentive": {
            "type": "fixed_amount",
            "value": "10.00",
            "price_rule_id": 1153259470987,
            "coupon": "UPPROMOTE_CUSTOMER_REFERRAL"
        },
        "program": "ODgyMTc="
    },
    "design": {
        "refer_customer_button": {
            "refer_button_text": "Refer & Earn $$",
            "refer_background_color": "#1d85e8",
            "refer_text_color": "#ffffff",
            "web_position": "right-bottom",
            "mobile_position": "right-bottom"
        },
        "refer_customer_invite": {
            "popup_header": "Invite & Get $30.00 off",
            "popup_description": "Send your friends a $10.00 discount off their UniqueHeat\u00ae purchase. Once they make a purchase, you'll earn $30.00 for each order as well! This reward can be redeemed for coupons.",
            "button_text_get_invite": "Get invite link",
            "button_copy_invite": "Copy invite link",
            "popup_background_color": "#1d85e8",
            "popup_text_color": "#ffffff"
        },
        "refer_customer_incentive_popup": {
            "shop_header": "You got $10.00 Off",
            "shop_description": "Congrats! Your friend has gifted you a coupon. Coupon will be automatically applied at the checkout page.",
            "shop_button_text": "Shop now",
            "shop_background_color": "#1d85e8",
            "shop_text_color": "#ffffff"
        }
    }
}